import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { GlobalSpinnerService } from '../../../../shared/components/loader-service/global-spinner.service';
import { Principal } from '../../../../shared/auth/principal.service';
import { SnackBarService } from '../../../../shared/services/snackbar.service';
import { DpConnectorsService } from '../../services/dp-connectors.service';
import { SortUtils } from '../../../../shared/utils/sort-utils';
import { AdStatsWidgetTypesService } from '../../../../shared/services/ad-stats-widget-types.service';
import { BridgeAdUnit } from '../../../../shared/domain/bridge-ad-unit.model';
import { PMSite } from '../../domain/dp-integration/pm-site.model';
import { PmSiteRequest } from '../../domain/dp-integration/pm-site-req.model';
import { PMAdUnit } from '../../domain/dp-integration/pm-ad-unit.model';
import { PMAdSize } from '../../domain/dp-integration/pm-ad-size.model';
import { ServerErrorUtils } from '../../../../shared/utils/server-error-utils';

@Component({
  selector: 'cm-kn-dp-autocreation-pubmatic-dialog.component',
  templateUrl: `./dp-autocreation-pubmatic-dialog.component.html`
})
export class DpAutocreationPubmaticComponent {

  siteList: PMSite[] = [];
  sizeList: PMAdSize[] = [];
  unitRequest: PMAdUnit = new PMAdUnit();

  siteRequest: PmSiteRequest = new PmSiteRequest();
  availableWidgetSizes: string[];
  adUnit: BridgeAdUnit;

  constructor(public dialogRef: MatDialogRef<DpAutocreationPubmaticComponent>,
              private gss: GlobalSpinnerService,
              private principal: Principal,
              private service: DpConnectorsService,
              private widgetTypesService: AdStatsWidgetTypesService,
              private sbs: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.adUnit = data.adUnit;
    this.unitRequest.adTagName = this.adUnit.name;
    this.refreshSizeList();
    this.refreshSitesList();
    this.widgetTypesService.getAll().subscribe(widgetTypes => {
      this.availableWidgetSizes = Array.from(new Set(widgetTypes.map(type => type.adWidth + 'x' + type.adHeight)));
      this.availableWidgetSizes.sort();
      const found = widgetTypes.find(t => t.name === this.adUnit.widgetName);
      // if (found) {
      //   this.unitRequest._size = found.adWidth + 'x' + found.adHeight;
      // }
    });
  }

  createUnit() {
    this.gss.showLoader();
    this.service.pubmaticUnitCreate(this.adUnit.id, this.unitRequest).subscribe(next => {
      this.gss.hideLoader();
      this.sbs.error('Ad unit created successfully in pubmatic');
      this.dialogRef.close(true);
    }, (e) => {
      this.gss.hideLoader();
      ServerErrorUtils.serverValidationOrMsg(e, this.sbs, 'Error during pubmatic ad unit creation');
    });
  }

  createSite() {
    this.gss.showLoader();
    this.service.pubmaticSiteCreate(this.siteRequest).subscribe(next => {
      this.gss.hideLoader();
      this.sbs.error('Site created successfully in appnexus');
      this.siteRequest = new PmSiteRequest();
    }, () => {
      this.gss.hideLoader();
      this.sbs.error('Error during pubmatic site creation');
    });
  }

  refreshSizeList() {
    this.service.pubmaticSizes().subscribe(next => {
      const availableSizeIds = [7, 9, 10, 31,];
      this.sizeList = next;
      this.sizeList = this.sizeList.filter(s => {
        return availableSizeIds.includes(s.id);
      });

      this.sizeList.sort(SortUtils.propertyComparatorNumber('width'));
      const found = this.sizeList.find(s => this.adUnit.widgetName.includes(s.width + 'x' + s.height));
      if (found) {
        this.unitRequest.adSize = found;
      }
    });
  }

  refreshSitesList() {
    this.service.pubmaticSites().subscribe(next => {
      this.siteList = next;
      this.siteList.sort(SortUtils.propertyComparatorString('siteUrl'));
      if (this.adUnit.publisher.pubmaticIdentifier) {
        const foundSite = this.siteList.find(s => s.siteUrl === this.adUnit.publisher.pubmaticIdentifier);
        if (foundSite) {
          this.unitRequest.publisherSiteurl = foundSite.siteUrl;
        }
      }
    });
  }

}
